<template>
  <div>
    <v-form ref="form">
      <v-text-field v-model="modality_infos.name" required prepend-icon="mdi-factory"
       label="Nome" :rules="required" type="text"></v-text-field>
      <v-text-field v-model="modality_infos.corporate_name" required prepend-icon="mdi-factory"
       label="Razão Social" :rules="required" type="text"></v-text-field>
      <v-text-field v-model="modality_infos.document" v-mask="'##.###.###/####-##'" required prepend-icon="mdi-text"
       label="CNPJ" :rules="cnpj"></v-text-field>
      <!-- <v-text-field v-model="modality_infos.company_pix" required prepend-icon="mdi-cash"
       label="Empresa Pix" :rules="required" type="text"></v-text-field> -->
      <v-textarea v-model="modality_infos.comment" prepend-icon="mdi-comment"
       label="Comentário" :rules="[ruleMaxLen(maxLen)]"></v-textarea>
  
      <!-- <v-container class="d-flex justify-center">
        <v-btn disabled color="primary">Selecionar Documento</v-btn>
      </v-container> -->
    </v-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {mask} from 'vue-the-mask'
import validations from "@/mixins/validations";

export default {
  name: 'ModalityInfosForm',
  mixins: [ validations ],
  directives: {mask},
  props: {
    modality_infos: {
      type: Object,
    },
  },
  data() {
    return {
        maxLen: 200,
    }
  },
  methods: {
    validate(){
      return this.$refs.form.validate()
    },
  },
  computed: {
    ...mapState({
      one_modality: state => state.Modality.one_modality
    })
  },
  watch: {
  },
}
</script>

<style lang="scss" scoped>

</style>
